import React from 'react'
import { Button } from 'react-bootstrap'
import { Trash3, Pencil } from 'react-bootstrap-icons'

import HoverOverlay from '../HoverOverlay/HoverOverlay'

interface IProps {
    editModal: () => void
    deleteModal: () => void
}

const CellButtonsClients = ({ editModal, deleteModal }: IProps) => {
    const stopPropagation = (event: React.MouseEvent) => {
        event.stopPropagation()
    }

    return (
        <>
            <HoverOverlay tooltipText={'Редактировать'}>
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={event => {
                        stopPropagation(event)
                        editModal()
                    }}
                    className="d-flex align-items-center"
                >
                    <Pencil color={'white'} size={18} />
                </Button>
            </HoverOverlay>
            <HoverOverlay tooltipText={'Удалить'}>
                <Button
                    variant="danger"
                    size="sm"
                    onClick={event => {
                        stopPropagation(event)
                        deleteModal()
                    }}
                    className="d-flex align-items-center"
                >
                    <Trash3 color={'white'} size={18} />
                </Button>
            </HoverOverlay>
        </>
    )
}

export default CellButtonsClients
